import { Component } from '@angular/core';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-analytic-type-info-dialog',
  templateUrl: './analytic-type-info-dialog.component.html',
  styleUrls: ['./analytic-type-info-dialog.component.scss'],
  standalone: false,
})
export class AnalyticTypeInfoDialogComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
}
